import { useState } from "react";
import down_arrow from "../../../../../assets/down_arrow.svg";

/**
 * Component for the button div in the NavBar
 * Enhanced for better responsiveness across all screen sizes
 * 
 * @param text - The text to display in the button
 * @param icon_name - The icon to display in the button (Can optionally be a string or a React component)
 * @param right_icon - Optional icon to display on the right side of the button
 */
export function NavBarButtonDiv({text, icon_name, right_icon}: {text: string, icon_name: string | React.ReactNode, right_icon?: string | React.ReactNode}) {
    const [is_open, setIsOpen] = useState(false);

    const handleClick = () => {
        // Only toggle the dropdown animation if the right_icon is the down_arrow
        if (right_icon === down_arrow) {
            setIsOpen(!is_open);
        }
    };

    return (
        <div 
            className="flex flex-row items-center justify-between w-full px-2 py-3 mx-auto transition md:py-4" 
            onClick={handleClick}
        >
            {typeof icon_name === "string" ? (
                <img 
                    src={icon_name} 
                    alt={text} 
                    className="w-4 min-w-4 dark:invert md:w-6 md:min-w-6" 
                /> 
            ) : (
                <div className="flex items-center justify-center min-w-4">
                    {icon_name}
                </div>
            )}

            <div className="w-full ml-2 overflow-hidden">
                <h5 className="text-xs text-left truncate md:text-sm dark:text-stone-100">
                    {text}
                </h5>
            </div>

            {right_icon && typeof right_icon === "string" ? (
                <img 
                    src={right_icon} 
                    alt={text} 
                    className="w-4 transition-all duration-200 min-w-4 dark:invert" 
                    style={{transform: is_open ? "rotate(180deg)" : "rotate(0deg)"}}
                /> 
            ) : (
                <div className="flex items-center justify-center min-w-4">
                    {right_icon}
                </div>
            )}
        </div>
    );
}
